import s from './BackButton.module.scss';
import Link from 'next/link';

export default function BackButton() {
    return (
        <Link href='/portafolio'>
            <div className={`${s.btn__container}`}>
                <div className="container">
                    <div className={s.back__btn}>
                        <img src="/arrow-right.png" alt="arrow back" />
                        <span>Back</span>
                    </div>
                </div>
            </div>
        </Link>
    )
}